import {useShiftQuery} from "../../api/shift.slice.ts";
import {useParams} from "react-router-dom";
import {DataLoadingError} from "../../components/DataLoadingError.tsx";
import {Input} from "../../components/Form/ConnectedInput.tsx";
import {RIODateTime} from "../../lib/RIODateTime.ts";
import {ActivityList} from "./ActivityList.tsx";
import humanizeDuration from "humanize-duration";

type StatItemProps = {
    timeValue: number,
    label: string,
}

const StatItem = ({timeValue, label}: StatItemProps) => (
    <div className='text-center bg-lightest rounded padding-10 flex-1-1-0 min-width-100'>
        <div className='text-size-20'>
            {humanizeDuration(timeValue * 1000)}
        </div>
        <div className='text-size-12 text-color-dark'>{label}</div>
    </div>
)

export const ShiftPage = () => {


    const {id} = useParams();
    const {data, isLoading, error} = useShiftQuery(id as any)

    console.log(error)

    if (!data)
        return "loading"

    return <DataLoadingError isLoading={isLoading} error={error}>
        <h1>Shift</h1>
        <div className='line-height-125rel max-width-1000'>
            <div className='display-flex flex-column gap-15'>
                <div className='display-flex align-items-start gap-10'>
                    <div>
                        <span className='rioglyph rioglyph-driver text-size-h1'/>
                    </div>
                    <div>
                        <div className='text-size-20 text-medium'>
                            {data?.driver.firstName} {data?.driver.lastName}
                        </div>
                        <div className='text-size-14 display-flex flex-wrap column-gap-25 row-gap-5'>
                            <span className='text-color-dark'>{data.driverId} | {data?.driver?.adnDocNumber}</span>
                            <span className=' display-flex gap-5 align-items-center whitespace-nowrap'>
                      <span className='rioglyph rioglyph-calendar'/>
                      <span className='text-color-dark'>Shift:</span>
                      <span>{RIODateTime.ToHumanReadable(data?.start)}</span>
                      <span className='rioglyph rioglyph-arrow-right'/>
                      <span>{RIODateTime.ToHumanReadable(data?.end)}</span>
                    </span>
                            <span className='display-flex gap-5 align-items-center whitespace-nowrap'>
                      <span className='rioglyph rioglyph-time-alt'/>
                      <span className='text-color-dark'>Shift type:</span>
                      <span>{data?.shiftType}</span>
                    </span>
                        </div>
                    </div>
                </div>
                <div className='display-flex flex-wrap gap-15'>
                    <StatItem timeValue={data?.totalDuration} label={"Duration"}/>
                    <StatItem timeValue={data?.drivingDuration} label={"DrivingDuration"}/>
                    <StatItem timeValue={data?.workingDuration} label={"WorkingDuration"}/>
                    <StatItem timeValue={data?.bankHolidayDuration} label={"BankHolidayDuration"}/>
                    {/*{stats.map((stat, index) => (*/}
                    {/*    <StatItem key={index} start={stat.start} end={stat.end} label={stat.label} unit={stat.unit}/>*/}
                    {/*))}*/}
                </div>
            </div>
        </div>

        <div className="display-grid grid-cols-3 gap-20">
            <section>
                <h3>Driver</h3>
                <Input readOnly={true} type={"text"} label={"Driver Name"} name={"driverName"}
                       value={data?.driver?.firstName + " " + data?.driver?.lastName}/>
                <Input readOnly={true} type={"text"} label={"RioId"} name={"rioId"}
                       value={data?.driverId}/>
                <Input type={"text"} label={"AdnDocNumber"} name={"adnDocNumber"} value={data?.driver?.adnDocNumber}/>
                <Input type={"text"} label={"Holiday Group"} name={"holidayGroup"} value={data?.driver?.holidayGroup}/>
            </section>
            <section>
                <h3>Durations</h3>
                <Input readOnly={true} type={"text"} label={"Duration"} name={"duration"} value={data!.totalDuration / 60}/>
                <Input readOnly={true} type={"text"} label={"Driving Duration"} name={"drivingDuration"}
                       value={data!.drivingDuration / 60}/>
                <Input readOnly={true} type={"text"} label={"Working Duration"} name={"workingDuration"}
                       value={data!.workingDuration / 60}/>
                <Input readOnly={true} type={"text"} label={"Bank Holiday Duration"} name={"bankHolidayDuration"}
                       value={data!.bankHolidayDuration / 60}/>
            </section>
            <section>
                <h3>Time Span</h3>
                <Input readOnly={true} type={"text"} label={"Start"} name={"start"}
                       value={RIODateTime.ToHumanReadable(data!.start)}/>
                <Input readOnly={true} type={"text"} label={"End"} name={"end"}
                       value={RIODateTime.ToHumanReadable(data!.end)}/>
            </section>
            <section>
                <h3>Surcharges</h3>
                {data!.applicableSurcharges.map(summary => (
                    <Input readOnly={true} value={summary.duration} type={"text"} label={summary.name}
                           name={summary.name}/>
                ))}
            </section>
            <section>
                <h3>Metadata</h3>
                <Input readOnly={true} type={"text"} label={"Shift Aggregation Type"} name={"type"}
                       value={data!.shiftType}/>
            </section>
        </div>


        <div>
            <h3>Activities</h3>
            <ActivityList data={data.activities}/>
        </div>
    </DataLoadingError>
}